export default __webpack_public_path__ + "static/media/moon-landing.e519f5ea.png";